<template>
    <CollapsibleCardBase>
        <template #title>
            <div class="mt-1 font-bold text-sm">
                {{ $t('component.missionProfile.livingSituation.title') }}
            </div>
        </template>
        <template #content>
            <div class="text-sm leading-tight text-gray-600">
                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.livingSituation.mission.city') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div class="mb-1 ml-1">{{ situationLocation() }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.livingSituation.accommodation') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div class="mb-1 ml-1">{{ situationAccommodation() }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.situation.smoker') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div class="mb-1 ml-1">{{ situationSmoker() }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.situation.family_members_nearby') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div class="mb-1 ml-1">{{ situationFamilyMembersNearby() }}</div>
                    </div>
                </div>
            </div>
        </template>
    </CollapsibleCardBase>
</template>

<script>
    import CollapsibleCardBase from "@/components/shared/CollapsibleCardBase";
    export default {
        name: "MissionProfileLivingSituation",
        props: ['missionDetail'],
        components: {CollapsibleCardBase},
        methods: {
            situationLocation() {
                let building = '';
                let neighbourhood = '';
                let location = '';

                if (this.missionDetail.situation === undefined)
                    return '';

                if (this.missionDetail.situation.location.building === 0) {
                    building = this.$t('component.missionProfile.livingSituation.location.building_0');
                } else if (this.missionDetail.situation.location.building === 1) {
                    building = this.$t('component.missionProfile.livingSituation.location.building_1');
                }

                if (this.missionDetail.situation.location.neighbourhood === null) {
                    neighbourhood = this.$t('text.unknown');
                } else if (this.missionDetail.situation.location.neighbourhood === 0) {
                    neighbourhood = this.$t('component.missionProfile.livingSituation.location.neighbourhood_0');
                } else if (this.missionDetail.situation.location.neighbourhood === 1) {
                    neighbourhood = this.$t('component.missionProfile.livingSituation.location.neighbourhood_1');
                } else if (this.missionDetail.situation.location.neighbourhood === 2) {
                    neighbourhood = this.$t('component.missionProfile.livingSituation.location.neighbourhood_2');
                }

                location = `${this.missionDetail.situation.location.city} (${neighbourhood}), ${building}`;

                return location;
            },

            situationAccommodation() {
                let accommodations = [];

                if (this.missionDetail.situation === undefined) {
                    return '';
                }

                if (this.missionDetail.situation.accommodation.free_phone_calls === null) {
                    accommodations.push(this.$t('text.unknown'));
                } else if (this.missionDetail.situation.accommodation.free_phone_calls === 1) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.free_phone_calls_1'));
                } else if (this.missionDetail.situation.accommodation.free_phone_calls === 2) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.free_phone_calls_2'));
                }

                if (this.missionDetail.situation.accommodation.internet === null) {
                    accommodations.push(this.$t('text.unknown'));
                } else if (this.missionDetail.situation.accommodation.internet === 1) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.internet_1'));
                } else if (this.missionDetail.situation.accommodation.internet === 2) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.internet_2'));
                }

                if (this.missionDetail.situation.accommodation.own_bath === true) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.own_bath'));
                }

                if (this.missionDetail.situation.accommodation.own_room === null) {
                    accommodations.push(this.$t('text.unknown'));
                } else if (this.missionDetail.situation.accommodation.own_room === 0) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.own_room_0'));
                } else if (this.missionDetail.situation.accommodation.own_room === 1) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.own_room_1'));
                } else if (this.missionDetail.situation.accommodation.own_room === 2) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.own_room_2'));
                }

                if (this.missionDetail.situation.accommodation.own_toilet === true) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.own_toilet'));
                }

                if (this.missionDetail.situation.accommodation.own_tv === true) {
                    accommodations.push(this.$t('component.missionProfile.situation.accommodation.own_tv'));
                }

                return accommodations.join(', ');
            },

            situationSmoker() {
                if (this.missionDetail.situation === undefined) {
                    return '';
                }

                if (this.missionDetail.situation.smokers === true) {
                    return this.$t('component.missionProfile.situation.smokers_0');
                } else {
                    return this.$t('component.missionProfile.situation.smokers_1');
                }
            },

            situationFamilyMembersNearby() {
                if (this.missionDetail.situation === undefined) {
                    return '';
                }

                if (this.missionDetail.situation.family_members_nearby === true) {
                    return this.$t('component.missionProfile.situation.family_members_nearby_0');
                } else {
                    return this.$t('component.missionProfile.situation.family_members_nearby_1');
                }
            }
        }
    }
</script>

<style scoped>

</style>